import { render, staticRenderFns } from "./GetClient.vue?vue&type=template&id=1b3644de&"
import script from "./GetClient.vue?vue&type=script&lang=js&"
export * from "./GetClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports